import { User } from 'packages/grimoire'
import { DayOfWeek } from 'packages/grimoire/src/utils'
import { createDateObject } from 'packages/utils/dateHelpers'
import {
  parseTimestampTo24HourIndex,
  twentyFourHourMap,
} from 'packages/utils/timestamp'

import { CrossCoverage } from 'app/fieldapp/store/crossCoverage/crossCoverage.types'

import { TimeOption } from '../components/TimeSelect'
import { CrossCoverageFormState } from './CrossCoverageForm.reducer'

//TODO: TPD-6418: Add tests transformCrossCoverageToFormState

/**
 * Takes a standard `CrossCoverage` Record and returns `CrossCoverageFormState` to populate the CrossCoverageForm.
 * This is currently used to populate the `CrossCoverageForm` when editing an existing `CrossCoverage,
 * however it could also be used in an offline flow similar to timers
 */
export const transformCrossCoverageToFormState = ({
  assignee,
  crossCoverage,
  standardPartnerId,
}: {
  assignee: User
  crossCoverage?: CrossCoverage | null
  standardPartnerId?: string
}): CrossCoverageFormState | undefined => {
  if (!crossCoverage) return undefined

  const endTime = parseTimestampTo24HourIndex(crossCoverage.endTimeLocal)
  const startTime = parseTimestampTo24HourIndex(crossCoverage.startTimeLocal)
  const endDate = createDateObject(crossCoverage.endDate)
  const startDate = createDateObject(crossCoverage.startDate)

  const endTimeOption: TimeOption = {
    hourOfDay: endTime.hourIndex24,
    timeOfDay: twentyFourHourMap[endTime.hourIndex24],
  }

  const startTimeOption: TimeOption = {
    hourOfDay: startTime.hourIndex24,
    timeOfDay: twentyFourHourMap[startTime.hourIndex24],
  }

  const repeatDays = [
    crossCoverage.monday ? 'monday' : undefined,
    crossCoverage.tuesday ? 'tuesday' : undefined,
    crossCoverage.wednesday ? 'wednesday' : undefined,
    crossCoverage.thursday ? 'thursday' : undefined,
    crossCoverage.friday ? 'friday' : undefined,
    crossCoverage.saturday ? 'saturday' : undefined,
    crossCoverage.sunday ? 'sunday' : undefined,
  ].filter(Boolean) as unknown as DayOfWeek[]

  const state: CrossCoverageFormState = {
    crossCoverageId: crossCoverage.id,
    endDate,
    endTime: endTimeOption,
    formValidationError: undefined,
    isAssigneeBeingOverridden: assignee.id !== standardPartnerId,
    isRepeating: crossCoverage.isRepeating,
    repeatDays,
    selectedAssignee: assignee,
    startDate,
    startTime: startTimeOption,
  }

  return state
}
